module.exports = __webpack_public_path__ + "static/blogbackground.fe3ddd9a.jpeg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/blogbackground.jpeg
// module id = 975
// module chunks = 0